import React, { FC, memo, Suspense } from "react";
import Layout from "layouts/Layout";
import { Outlet } from "react-router-dom";
import styled from "styled-components";
import { ChatWidget } from "../../../components/ChatWidget/ChatWidget";
import { MainAppLogo } from "../../../components/MainAppLogo";
import Loading from "../../../components/LoadingPage/LoadingPage";
import { HeadingLink, Wrapper } from "../../../styles/formStyles";

interface PublicRouteProps {
  withMenu?: boolean;
}

const PublicRoute: FC<PublicRouteProps> = ({ withMenu = false }) => (
  <Layout withMenu={withMenu}>
    <Wrapper>
      <HeadingLink to="/">
        <MainAppLogo />
      </HeadingLink>
      <Suspense fallback={<Loading />}>
        <Outlet />
      </Suspense>
    </Wrapper>
    <ChatWrapper>
      <ChatWidget />
    </ChatWrapper>
  </Layout>
);

export default memo(PublicRoute);

// Fixed-position slot for ChatWidget on public routes (no Nav rendered).
// Mirrors the original IntercomWrapper coordinates pre-Phase-3.5.
const ChatWrapper = styled.div`
  position: fixed;
  left: 40px;
  bottom: 20px;
`;
